module.exports = __webpack_public_path__ + "e79e71f2dd501da354eccdd0adde81cf.jpg";